export const getOcccasionsList = ({ state }) => state.occasions.occasionsList;
export const getOcccasionsCardsList = ({ state }) => state.occasions.occasionsFinalCardsList;
export const getSelectedOcccasionsCardsIds = ({ state }) =>
  state.occasions.selectedOccasionsCardsIds;
